import { createFileRoute } from '@tanstack/react-router';
import { useNotificationSettings } from '@/hooks/use-notification-settings';
import { NotificationSettingsForm } from '@/features/notifications/components/notification-settings-form';
import { PageLoader } from '@/components/page-loader';

export const Route = createFileRoute('/dashboard/notifications/')({
  component: NotificationsPage,
});

function NotificationsPage() {
  const { data: settings, isLoading } = useNotificationSettings();

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="font-display text-2xl font-medium tracking-tight text-foreground">
          Notifications
        </h1>
        <p className="text-muted-foreground text-sm mt-1">Choose how we reach you</p>
      </div>

      {isLoading || !settings ? <PageLoader /> : <NotificationSettingsForm settings={settings} />}
    </div>
  );
}
